import { fetchApi } from "@/utils/axios";
import URL from "@/api/urlConfig"

// 新增账户
export const addAccount = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_ADD, data, "post", "data");
};
// 详情
export const getAccountDetail = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_DETAIL, data, "get", "params");
};
// 更新
export const updateAccount = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_EDIT, data, "post", "data");
};
// 删除
export const deleteAccount = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_DELETE, data, "get", "params");
};
// 更新状态
export const changeStatus = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_CHANGE_STATUS, data, "get", "params");
};
// 分页数据
export const getAccountList = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_LIST, data, "post", "data");
};
// 角色option
export const getRoleOptions = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_ROLE_OPTION, data, "get", "params");
};
// 账户项目
export const getAccountProjects = (data) => {
  return fetchApi(URL.CLIENT_OPERATION_ACCOUNT_PROJECT_LIST, data, "get", "params");
};